import { SEO } from "@/components/SEO";
import { headTageTitle } from "@/utils/head-tag-title";
import { getConfigSSR } from "api/config";
import { useMemo } from "react";
import { useAppSelector } from "store/hooks";
import { ConfigPage, NextPageWithLayoutAndPageType } from "types/index";

const FAQPage: NextPageWithLayoutAndPageType = (props: any) => {
  const storeConfig = useAppSelector((state) => state.config);
  const config = props.config || storeConfig;
  const siteTitleFromHeadTag = useMemo(() => headTageTitle(config), [config]);

  const siteName = siteTitleFromHeadTag
    ? siteTitleFromHeadTag
    : config.company_info?.name;
  const seoconfig = config.pages?.find(
    (page: ConfigPage) => page?.page_type === "faq",
  )?.config;
  const description =
    seoconfig?.description ||
    `Find answers to common questions about booking tickets, refunds, seat selection, and more at ${siteName}.`;
  const title = seoconfig?.title || "FAQ - Frequently Asked Questions";
  const keywords = seoconfig?.keywords || [
    "FAQ",
    "questions",
    "help",
    "support",
    "booking help",
    siteName,
  ];

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      siteName={siteName}
    />
  );
};

FAQPage.page_type = "faq";
export const getServerSideProps = getConfigSSR;

export default FAQPage;
